module.exports = __webpack_public_path__ + "img/icon-add.fc1daf84.svg";